// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"685":"7e80ab9859848264","888":"881f3e803a598be1"}[chunkId] + ".css";
};